import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { View } from '@olxbr/design-system'

import HRule from '../../atoms/HRule'
import TextCallout from '../../molecules/TextCallout'
import Paper from '../../atoms/Paper'
import LogoTitle from '../../molecules/LogoTitle'
import TermsAndPrivacyNotice from '../../molecules/TermsAndPrivacyNotice'
import MagicLinkEmailSentTemplate from '../../templates/MagicLinkEmailSentTemplate'

import medias from '../../../util/medias'

const Content = styled(View)`
  display: flex;
  flex-direction: column;
  margin: ${() => '64px auto'};
  max-width: 466px;
  ${medias.medium`
    margin: 0;
  `}
`

const HRuleWrapper = styled(View)`
  margin-top: 34px;
  margin-right: 0;
  margin-bottom: 28px;
  margin-left: 0;
`

const FooterWrapper = styled(View)`
  display: flex;
  margin-top: 24px;
`

export const MagicLinkEmailSentPage = ({ email }) => (
  <Content>
    <Paper>
      <LogoTitle title="Acesso rápido enviado!" />
      <MagicLinkEmailSentTemplate email={email} />
      <HRuleWrapper>
        <HRule />
      </HRuleWrapper>
      <TextCallout text="Voltar para" linkText="Acesse sua conta" href="/acesso" />
    </Paper>
    <FooterWrapper>
      <TermsAndPrivacyNotice />
    </FooterWrapper>
  </Content>
)

MagicLinkEmailSentPage.propTypes = {
  email: PropTypes.string.isRequired,
}
